import React, { useContext } from 'react'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { useTranslation } from 'react-i18next';
import './ResultBlock.scss'
import { Context } from '../../AppContext';

const ResultBlock = ({ valueFrom, valueTo, totalVolume, totalKg, totalPlaces }) => {
    const { t } = useTranslation()
    const { totalCount } = useContext(Context)

    return (
        <div className="result-block">
            <div className="result-block__content">
                <h2> {t("result.title")} </h2>

                {valueFrom && valueTo ?
                    (
                        <div className="result-block__total">
                            <div className="result-block__total-cargo">
                                <h3> {t("result.cargo")}: </h3>
                                {`${totalVolume / 1000000}`} {t("m")}³.,
                                {` ${totalKg}`} {t("kg")}.,
                                {` ${totalPlaces}`} {t("seats")}.
                                <br />
                            </div>
                            <div className="result-block__total-routs">
                                <h3> {t("result.route")}: </h3>
                                <div className="result-block-row">
                                    <div className="result-block__point">
                                        <PlaceOutlinedIcon />
                                        <span> {valueFrom} </span>
                                        <ArrowForwardOutlinedIcon />
                                        <PlaceOutlinedIcon />
                                        <span> {valueTo} </span>
                                    </div>
                                </div>
                            </div>
                            {totalCount && (
                                <div className="result-block__total-count">
                                    <h3> {t('warning.approximate_total')}: </h3>
                                    <div className="result-block-row">
                                        <span>
                                            {totalCount}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) :
                    <>
                        <p>{t("result.text")}</p>
                    </>
                }
            </div>
        </div>
    )
}

export default ResultBlock